export default ({ data }, { market, t }) => {
  if (!data) {
    return {};
  }

  const year = data.shopOfTheYear ? data.shopOfTheYear.year : '';
  const cdnDir = `${market.cdn}/g/store_of_the_year/${year}/${market.code}`;
  const badgeURI = `${cdnDir}/award/main_award.png`;

  const openGraph = [
    {
      key: 'title',
      content: t('campaigns', 'shop-of-the-year.meta-title', { year }),
    },
    { key: 'type', content: 'website' },
    { key: 'image', content: badgeURI },
  ];

  return {
    thumbnail: badgeURI,
    description: t('campaigns', 'shop-of-the-year.header-description', {
      year,
    }),
    title: t('campaigns', 'shop-of-the-year.title'),
    openGraph,
    structuredData: undefined,
    hrefLang: [],
  };
};
